import React from 'react'

function AdminPayments() {
  return (
    <div>AdminPayments</div>
  )
}

export default AdminPayments